// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{ groupName?: string; lineIds?: string[]; selectAll?: boolean; clearAll?: boolean }>;

export const DispatchUpdateLoadParameter: HandlerType = props => {
    const selectedLines =
        props.parameter.groupName && props.parameter.lineIds
            ? (props.getState() as any).myCustomQuoteDetails.selectedLineIds[props.parameter.groupName]
            : {};

    props.dispatch({
        type: "Pages/MyCustomQuotes/SetSelectedLines",
        groupName: props.parameter.groupName,
        lineIds: props.parameter.lineIds,
        selectAll: props.parameter.selectAll,
        clearAll: props.parameter.clearAll,
        selectedLines,
    } as any);
};

export const chain = [DispatchUpdateLoadParameter];

const setSelectedLines = createHandlerChainRunner(chain, "SetSelectedLines");
export default setSelectedLines;
